import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import Navbar from '../Navbar';
import Footer from '../Footer';

const Contact = () => {
  const form = useRef();
  const [formData, setFormData] = useState({
    from_name: '',
    reply_to: '',
    department: '',
    message: ''
  });
  const [status, setStatus] = useState({
    loading: false,
    error: null,
    success: false
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: null, success: false });
    
    try {
      
      const result = await emailjs.sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID, 
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      if (result.text !== 'OK') {
        throw new Error('Failed to send message');
      }
      
      setStatus({ loading: false, error: null, success: true });
      setFormData({ from_name: '', reply_to: '', department: '', message: '' });
    } catch (error) {
      setStatus({ loading: false, error: 'Failed to send message. Please try again later.', success: false });
      console.error('Contact form error:', error);
    }
  };

  return (
    <div className="page-container">
      <Navbar />
      <main className="content-wrapper">
        <section className="page-header">
          <h1>Contact Us</h1>
          <p>Get in touch with our team</p>
        </section>
        
        <section className="contact-content">
          <div className="contact-form-container">
            <h2>Send us a Message</h2>
            {status.success && (
              <div className="success-message">
                Thank you for your message! We'll get back to you soon.
              </div>
            )}
            {status.error && (
              <div className="error-message">
                {status.error}
              </div>
            )}
            <form ref={form} className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="from_name"
                  value={formData.from_name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="reply_to"
                  value={formData.reply_to}
                  onChange={handleChange}
                  placeholder="Your Email"
                  required
                />
              </div>
              <div className="form-group">
                <select
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Inquiry Type</option>
                  <option value="general">General</option>
                  <option value="demo">Request Demo</option>
                  <option value="partnership">Partnership</option>
                  <option value="sales">Sales</option>
                  <option value="support">Support</option>
                </select>
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Your Message"
                  rows="5"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="submit-button"
                disabled={status.loading}
              >
                {status.loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
          
          <div className="contact-info">
            <h2>Other Ways to Connect</h2>
            <div className="info-items">
              <div className="info-item">
                <h3>Email</h3>
                <p><a href="mailto:hello@lawsutra.ai">hello@lawsutra.ai</a></p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Contact;